export default __webpack_public_path__ + "87d9adf.png";